import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { CompletionStatuses } from '../../../../../constants';
import { RecommendationBaseView } from '../../../../sharedComponents/RecommendationBaseView';
import { CopyRichTextButton } from './CopyRichTextButton';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoPillarPage = ({
  clusterLink
}) => {
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_HYPERLINK_TO_PILLAR_PAGE.extraDescription.noPillarPage.text"
    }), /*#__PURE__*/_jsx(Link, {
      href: clusterLink,
      external: true,
      paddingInlineStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.description.ADD_HYPERLINK_TO_PILLAR_PAGE.extraDescription.noPillarPage.linkText"
      })
    })]
  });
};
const CopyPillarPageUrlButton = ({
  anchor
}) => {
  return /*#__PURE__*/_jsx(CopyRichTextButton, {
    value: anchor,
    htmlValue: anchor,
    hint: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_HYPERLINK_TO_PILLAR_PAGE.extraDescription.copyRichTextButton.hint"
    }),
    tooltipPlacement: "right",
    use: "tertiary",
    size: "small",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_HYPERLINK_TO_PILLAR_PAGE.extraDescription.copyRichTextButton.buttonText"
    })
  });
};
export const AddHyperlinkToPillarPageView = ({
  auditResult
}) => {
  const {
    status,
    clusterLink,
    clusterPhrase,
    anchor
  } = auditResult;
  const isIncomplete = status === CompletionStatuses.INCOMPLETE;
  const isNoPillarPage = isIncomplete && !!clusterLink;
  const isNotLinkedToPillarPage = isIncomplete && !!anchor;
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.ADD_HYPERLINK_TO_PILLAR_PAGE"
    }),
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_HYPERLINK_TO_PILLAR_PAGE.mainText",
      options: {
        clusterPhrase
      }
    }),
    status: status,
    children: /*#__PURE__*/_jsxs(View, {
      marginInlineStart: "600",
      as: "div",
      children: [isNoPillarPage && /*#__PURE__*/_jsx(NoPillarPage, {
        clusterLink: clusterLink
      }), isNotLinkedToPillarPage && /*#__PURE__*/_jsx(CopyPillarPageUrlButton, {
        anchor: anchor
      })]
    })
  });
};